import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import styles from './_myRoutesModule.css'
import paginator from 'services/paginator/paginator'
import { FormattedMessage } from 'react-intl'
import { selectUserId } from 'services/user/selectors'
import * as routeActions from 'services/routes/actions'
import RouteRow from './RouteRow'
import Loader from 'components/util/Loader'

const paginatorOptions = {
  name: 'bookmarkedRoutesModule',
  perPage: 5,
  maxPageButtons: 3,
}

const mapStateToProps = (state) => ({
  userId: selectUserId(state),
})

const mapDispatchToActions = {
  ...routeActions,
}

export class MyRoutes extends Component {

  static propTypes = {
    onSelect: PropTypes.func,
    getBookmarkedRoutes: PropTypes.func,
    userId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    paginator: PropTypes.object,
  }

  handleClickRoute = (route) => () => {
    this.props.onSelect(route)
  }

  loadPaginatorPage = ({ limit, offset }) => {
    return this.props.getBookmarkedRoutes({
      limit,
      offset,
      userId: this.props.userId,
    })
  }

  render () {
    const { paginator: { results, loading }} = this.props

    return (
      <table className={styles.table}>
        <thead>
          <tr className={styles.thead}>
            <th className={styles.th}>
              <FormattedMessage
                id='routes.my_routes_module.bookmarked.distance_header'
                defaultMessage='Distance'
              />
            </th>
            <th className={styles.th}>
              <FormattedMessage
                id='routes.my_routes_module.bookmarked.name_created_header'
                defaultMessage='Name, Created Date'
              />
            </th>
            <th className={styles.th}>
              <FormattedMessage
                id='routes.my_routes_module.bookmarked.location_header'
                defaultMessage='Location'
              />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colSpan='3'>
              <div className={styles.body}>

                {loading ?
                  <div className={styles.emptyTable}>
                    <div className={styles.tableLoader}>
                      <Loader
                        type='pulse'
                        height={60}
                        width={60}
                        style={{ marginTop: 150 }}
                      />
                    </div>
                  </div>
                : null}

                {!loading && results && results.length ?
                  results.map((route, i) => (
                    <RouteRow
                      key={i}
                      route={route}
                      onClick={this.handleClickRoute(route)}
                    />
                  ))
                : null}

                {!loading && results && !results.length ?
                  <div className={styles.emptyTable}>
                    <FormattedMessage
                      id='routes.my_routes_module.no_bookmarks'
                      defaultMessage='No bookmarks found.'
                    />
                  </div>
                : null}

              </div>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }
}

export const Table = paginator(paginatorOptions)(MyRoutes)
export default connect(mapStateToProps, mapDispatchToActions)(Table)



// WEBPACK FOOTER //
// ./src/components/routes/MyRoutesModule/BookmarkedRoutes.jsx